/* eslint-disable react/prop-types */
/** @jsxImportSource @emotion/react */

import { Skeleton } from '@nike/nike-design-system-components';
import { useSelector } from 'react-redux';

import { requestsSelectors } from '../../requests/reducer';
import { usersSelectors } from './reducer';

const UserTableRowSkeleton = ({ targetRef }) => {
  const searchUsersInProgress = useSelector(requestsSelectors.searchUsersInProgress);
  const totalUsers = useSelector(usersSelectors.totalUsers);
  const users = useSelector(usersSelectors.usersByIdList);

  return targetRef?.current && users.length < totalUsers ? (
    <Skeleton
      css={{
        visibility: searchUsersInProgress ? 'visible' : 'hidden'
      }}
      height={`${targetRef?.current?.clientHeight}px`}
      width={`${targetRef?.current?.clientWidth}px`}
    />
  ) : null;
};

export default UserTableRowSkeleton;
